import React, { useState } from 'react';

export default function PatientPanel({ procedures, summary }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (summary) {
      navigator.clipboard.writeText(summary);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const handlePrint = () => {
    const lines = [
      'ClarityMD \u2014 Patient Summary',
      '',
      summary || '',
      '',
      'Expected Recovery:',
      ...procedures.map((p) => `\u2022 ${p.procedure}: ~${p.recovery_weeks || '12\u201316'} weeks`),
    ];
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    const doc = iframe.contentDocument || iframe.contentWindow.document;
    doc.write(
      `<!DOCTYPE html><html><head><title>ClarityMD \u2014 Patient Summary</title>` +
      `<style>body{font-family:Arial,sans-serif;line-height:1.7;padding:28px;color:#1D2939}` +
      `h1{color:#003087;margin-bottom:20px}pre{white-space:pre-wrap;font-size:14px}</style>` +
      `</head><body><h1>ClarityMD \u2014 Patient Summary</h1>` +
      `<pre>${lines.join('\n')}</pre></body></html>`
    );
    doc.close();
    setTimeout(() => {
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    }, 250);
  };

  if (!procedures || procedures.length === 0) {
    return (
      <div className="card">
        <div className="empty-state">
          <div className="empty-icon">
            <svg viewBox="0 0 24 24" width="40" height="40"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
          </div>
          <div className="empty-title">Patient Summary</div>
          <div className="empty-desc">
            A plain-language explanation will appear here after analysis.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="card" style={{ display: 'flex', flexDirection: 'column' }}>
      <div className="card-header">
        <div className="card-title">
          <div className="card-icon">
            <svg viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
          </div>
          Patient-Friendly Summary
        </div>
        <div className="btn-row no-print">
          <button className="btn btn-ghost btn-sm" onClick={handleCopy}>
            {copied ? 'Copied' : 'Copy'}
          </button>
          <button className="btn btn-ghost btn-sm" onClick={handlePrint}>
            Print
          </button>
        </div>
      </div>

      <div className="card-body" style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 200px)' }}>
        {summary && (
          <>
            <div className="ai-disclaimer">
              <svg className="ai-disclaimer-icon" viewBox="0 0 24 24">
                <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
                <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
              </svg>
              <div className="ai-disclaimer-text">
                <strong>For informational purposes only.</strong> These procedure suggestions are
                generated by AI based on the patient profile provided. All clinical decisions,
                diagnoses, and treatment plans remain the sole responsibility of the treating surgeon.
                This tool does not replace professional medical judgment.
              </div>
            </div>
            <div className="section-label">Plain-Language Explanation</div>
            <div className="patient-summary">{summary}</div>
            <hr className="divider" />
          </>
        )}

        <div className="section-label">Expected Recovery Timeline</div>
        <div className="timeline">
          {procedures.map((proc, idx) => (
            <div key={idx} className={`tl-item${idx === 0 ? ' first-pick' : ''}`}>
              <div className="tl-dot" />
              <div className="tl-name">{proc.procedure}</div>
              <div className="tl-detail">
                ~{proc.recovery_weeks || '12\u201316'} weeks
                {proc.product ? ` \u00b7 ${proc.product}` : ''}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}


